import { defineStore } from "pinia";
import SettingResource from "~/models/Setting";

const getSettingValue = (value) => {
  if (value === null || value === true || value === false || value === "") {
    return value;
  }
  if (!isNaN(Number(value))) {
    return Number(value);
  }

  return value;
};

export const useJobCoachStore = defineStore("jobcoach", {
  state: () => ({
    settings: [],
    settings_schema: {
      admin_level: {
        label: "Minimum Admin Level",
        disabled: true,
        cast: Number,
        field_type: "input",
      },
      min_score: {
        label: "Minimum Score Value",
        cast: Number,
        field_type: "input",
      },
      max_score: {
        label: "Maximum Score Value",
        cast: Number,
        field_type: "input",
      },
      score_key: {
        label: "Score Evaluation Scale",
        cast: String,
        field_type: "wysiwyg",
      },
    },
    admin_level: 3,
    min_score: 1,
    max_score: 10,
    score_key: "",
  }),
  getters: {
    edit_allowed: () => {
      const auth = useAuthStore();
      return auth.isAuthenticated && auth.user.hasPermission('jc-settings');
    },
  },
  actions: {
    setSettings(settings) {
      this.settings = settings;
      settings.forEach((setting) => {
        this[setting.name] = getSettingValue(setting.value);
      });
    },
    loadConfig() {
      return SettingResource.where("system", "jc")
        .get()
        .then((response) => {
          this.setSettings(response.data);
        });
    },
  },
});
